module.exports = __webpack_public_path__ + "img/parfianowicz.bdd940bf.jpg";